import { StatusWidget } from "../../../Helper/ChatWidget";
import { Card, Eyebrow, Pill, Timeline } from "../ChatWidgetPrimitives";
import "./StatusCard.scss";

/** 05 Status: where something stands (a bug fix, a request, an incident). */
export const StatusCard = ({ widget }: { widget: StatusWidget }) => (
  <Card className="cw-status" label={widget.title}>
    <div className="cw-pad">
      {(widget.eyebrow || widget.status) && (
        <div className="cw-row">
          {widget.eyebrow ? <Eyebrow>{widget.eyebrow}</Eyebrow> : <span />}
          <Pill status={widget.status} />
        </div>
      )}
      {widget.title && (
        <div className="cw-h cw-status-title">{widget.title}</div>
      )}
      {widget.subtitle && (
        <div className="cw-sm cw-muted">{widget.subtitle}</div>
      )}
      {widget.steps && widget.steps.length > 0 && (
        <Timeline steps={widget.steps} />
      )}
      {widget.footnote && (
        <div className="cw-sm cw-muted cw-status-foot">{widget.footnote}</div>
      )}
    </div>
  </Card>
);
